

































































































































































































































import { Component, Mixins, Prop } from "vue-property-decorator";
import tablePagination from "@/mixins/tablePagination";
import loading from "@/mixins/loading";
import copy from "@/utils/deepCopy";
import clipboard from "clipboard";

import {
  productList,
  checktProductClass,
  createProduct,
  updateProduct,
  updateStatus,
  getQRCode,
} from "@/api/productList";

@Component
export default class Item extends Mixins(loading, tablePagination) {
  @Prop() tableData!: any;
  @Prop() itemTotal!: any;
  dialogVisibleImg = false;
  dialogVisibleShare = false;
  imgUrl = "";
  minPath = "pages/index/pages/product-detail/index?id=";
  curProduct: any = {};


  getData(){
    this.$emit("getData",this.currentPage);
  }

  handleShare(row: any) {
    this.showLoading();
    this.curProduct = copy(row);
    this.curProduct.minPath = this.minPath + row.id;

    getQRCode({
      id: row.id,
      path: this.minPath + row.id,
    })
      .then((res: any) => {
        this.curProduct.minImg = res.data;
        this.curProduct.minPath = this.minPath + row.id;
        this.dialogVisibleShare = true;
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  handleUpdate(title:string,key:string,row: any,item?:any) {
    let pom:any = {};
    this.$prompt(`请输入${title}`, {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      inputPattern: /^[1-9]\d*$/,
      inputErrorMessage: '请输入数字'
    }).then((val:any) => {
      let temp = val.value;

      if(key =='sort'){
        pom = copy(row);
        pom.sort = temp;
      }
      if(key =='stock'){
        item.stock = temp;
        pom = copy(row);
      }
      this.showLoading();
      updateProduct(pom)
        .then(() => {
          this.$message.success("修改成功");
          this.$emit("getData",this.currentPage);
        })
        .finally(() => {
          this.hideLoading();
        });
    });
  }

  handleCopy(row: any) {
    let pom = copy(row);
    this.$confirm(`确定复制？`, "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      this.showLoading();
      pom.pmsProductSkus.forEach((e: any) => {
        delete e.id;
        delete e.productId;
      });

      createProduct(pom)
        .then((res) => {
          this.$message.success("复制成功");
          this.$emit("getData",this.currentPage);
        })
        .finally(() => {
          this.hideLoading();
        });
    });
  }

  handleEdit(pid: any) {
    this.$router.push({
      path: "/editProduct",
      query: { pid: pid },
    });
  }
  // 修改商品上下架
  handleUpDown(row: any) {
    this.$confirm(
      `是否设置商品ID: ${row.id} 为 ${
        row.publishStatus == 0 ? "上架" : "下架"
      } 状态`,
      "提示",
      {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }
    ).then(() => {
      updateStatus({
        id: row.id,
        publishStatus: row.publishStatus == 0 ? 1 : 0,
      }).then((res: any) => {
        if (res.code == 200) {
          this.$message.success("更新成功");
          this.$emit("getData",this.currentPage);
        }
      });
    });
  }
  previewImg(url: any) {
    this.imgUrl = url;
    this.dialogVisibleImg = true;
  }

  copy(minPath: string) {
    let clipboardInfo = new clipboard(".cobyAddInfo", {
      text: function () {
        return minPath;
      },
    });
    clipboardInfo.on("success", () => {
      this.$message.success("复制成功");
      clipboardInfo.destroy();
    });
    clipboardInfo.on("error", () => {
      this.$message.error("复制失败，请手动复制");
    });
  }

  down(minImg: string) {
    let a = document.createElement("a");
    a.setAttribute("href", minImg);
    a.setAttribute("target", "_blank");
    a.click();
  }
}
